import React from 'react';
import {Card, CardHeader, CardMedia, CardText} from 'material-ui/Card';
import Chip from 'material-ui/Chip';
import Avatar from 'material-ui/Avatar';

const styles = {
  card:{
    margin:8,
  },
  cardheader:{
    padding:8,
    paddingBottom:0,
  },
  maintext:{
    paddingTop:0,
    paddingBottom:0,
  },
  chip: {
    margin: 4,
    backgroundColor:"rgb(240,240,240)"
  },
  wrapper: {
    display: 'flex',
    flexWrap: 'wrap',
  },
};

export default class EducationWisc extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      expanded: false,
    };
  }

  handleExpandChange = (expanded) => {
    this.setState({expanded: expanded});
  };

  handleToggle = (event, toggle) => {
    this.setState({expanded: toggle});
  };

  handleExpand = () => {
    this.setState({expanded: true});
  };

  handleReduce = () => {
    this.setState({expanded: false});
  };

  render() {
    return (
      <Card
        expanded={this.state.expanded}
        onExpandChange={this.handleExpandChange}
        style={styles.card}
      >
        <CardHeader
          title="University of Wisconsin -­ Madison"
          subtitle="M.S. Mechanical Engineering, Research Assistant: 2002-2004, 3.9 GPA"
          avatar="images/wisc.jpg"
          actAsExpander={true}
          showExpandableButton={this.props.showCarrot}
          style={styles.cardheader}
        />
        <CardText
          style={styles.maintext}
        >
          <ul>
            <li>Thesis: <i>Design and Development of a High­-Speed, High-­Flow, Three-­Way Hydraulic Valve</i></li>
            <li>Researched, designed, simulated, fabricated, and tested a hydraulic relay valve.</li>
            <li>
              Relevant classes/experience:
              <div style={styles.wrapper}>
                <Chip style={styles.chip}>
                  <Avatar size={32}>F03</Avatar>
                  Design w/Polymers
                </Chip>
                <Chip style={styles.chip}>
                  <Avatar size={32}>F02</Avatar>
                  Product Design
                </Chip>
                <Chip style={styles.chip}>
                  Pro/E
                </Chip>
                <Chip style={styles.chip}>
                  MATLAB Simulink
                </Chip>
                <Chip style={styles.chip}>
                  ANSYS
                </Chip>
                <Chip style={styles.chip}>
                  LabVIEW
                </Chip>
              </div>
            </li>
          </ul>
        </CardText>
        <CardMedia
          expandable={true}

        >
          <img src="images/gradschool3.jpg" alt="" />
        </CardMedia>
        <CardText expandable={true}>
          This relay valve was designed to be a component of a hypothetical hydraulic
          pump/motor with virtually variable displacement. The pump/motor was targeted for
          use in a hydraulic hybrid vehicle and was developed by Michael Nieling and Prof. Frank Fronczak.
          <br /><br />
          The valve is capable of a very fast response time (~4ms).
          <br /><br />
          Links:
          <ul>
            <li>
              <a href="https://search.library.wisc.edu/catalog/999972795102121" target="_blank" rel="noopener noreferrer">
                Thesis
              </a>
            </li>
            <li>
              <a href="https://search.library.wisc.edu/catalog/999949397502121" target="_blank" rel="noopener noreferrer">
                Mike Nieling's Thesis
              </a>
            </li>
          </ul>

        </CardText>
      </Card>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/EducationWisc.js